import { boolean, defineAction, number, object, string } from '~/prix'
import synchronizeAppSebraeAction from './synchronizeAppSebrae.action.json'

const synchronizeAppSebraeDefinition = defineAction({
  ...synchronizeAppSebraeAction,
  input: object({
    id: string(),
    force: boolean(),
    verbose: boolean(),
    onlyMissing: boolean(),
    skipInternalGeocoding: boolean(),
    year: number(),
  }),
  output: object({
    ok: boolean(),
  }),
})

export default synchronizeAppSebraeDefinition
